import { classnames } from '@aibees/shared/utils';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { config } from '../relevancy-summary-popup/config';
import * as Styled from './styles';
import * as SX from './sx';
import type { RelevancySummaryPopupContentProps as Props } from './types';

export const RelevancySummaryPopupContent = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('RelevancySummaryPopupContent', className)}
      sx={SX.root}
    >
      <Box sx={SX.column}>
        {config.map((x, index) => (
          <Box key={index} sx={SX.content}>
            <Box sx={SX.leftSide}>
              <Box sx={SX.circular}>
                <Stack sx={{ position: 'relative' }}>
                  <svg width={0} height={0}>
                    <defs>
                      <linearGradient
                        id={`my_gradient_${index}`}
                        x1="0%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                      >
                        <stop offset="0%" stopColor={x.stopColor1} />
                        <stop offset="100%" stopColor={x.stopColor2} />
                      </linearGradient>
                    </defs>
                  </svg>
                  <CircularProgress
                    variant="determinate"
                    sx={(theme) => ({
                      color: theme.palette.grey[200],
                      ...theme.applyStyles('dark', {
                        color: theme.palette.grey[800],
                      }),
                    })}
                    size={32}
                    thickness={4}
                    value={100}
                  />
                  <CircularProgress
                    variant="determinate"
                    disableShrink
                    sx={(theme) => ({
                      animationDuration: '550ms',
                      position: 'absolute',
                      left: 0,
                      'svg circle': { stroke: `url(#my_gradient_${index})` },
                    })}
                    size={32}
                    thickness={4}
                    value={x.percent}
                  />
                </Stack>

                <Box
                  top={0}
                  left={0}
                  bottom={6}
                  right={0}
                  position="absolute"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                >
                  <Typography
                    variant="body4"
                    component="div"
                    color="textSecondary"
                  >
                    <Typography sx={SX.grade({ grade: x.grade })}>
                      {x.grade}
                    </Typography>
                  </Typography>
                </Box>
              </Box>

              <Typography variant="body3" color="grey.500" fontWeight={400}>
                {x.title}
              </Typography>
            </Box>

            <Typography variant="body3" color="grey.600" fontWeight={600}>
              {x.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Styled.Wrapper>
  );
});

RelevancySummaryPopupContent.displayName = 'RelevancySummaryPopupContent';
